import Repository from '@/repositories/repository'

const MobileTradingAppRepository = {
  async getMobileTradingAppData(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('hantec-mobile-trading-app', 'page', params)
  }
}

export default MobileTradingAppRepository
